import { ChangesTab } from '@/features/leads/components/Detail/Tabs/ChangesTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/changes')({
  component: ChangesTab,
});
